// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ObjectAvatar-file__lhx2d{background-color:var(--gray-3)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"file": "ObjectAvatar-file__lhx2d"
};
export default ___CSS_LOADER_EXPORT___;
